import React, { useRef, useState, useEffect } from "react";
import '../style/components/_accordion.scss';

const Accordion = ({ title, duration, description, moreinfo, initiallyOpen = false, forceOpen }) => {
    const contentHeight = useRef(null);
    const accordionRef = useRef(null);
    const [isOpen, setIsOpen] = useState(initiallyOpen);
    const [height, setHeight] = useState("auto");

    useEffect(() => {
        if (typeof forceOpen === "boolean") {
            setIsOpen(forceOpen);
        }
    }, [forceOpen]);

    useEffect(() => {
        if (contentHeight.current) {
            setHeight(isOpen ? `${contentHeight.current.scrollHeight}px` : "0px");
        }
    }, [isOpen]);

    const toggleAccordion = () => {
        if (!isOpen) {
            document.querySelectorAll('.accordion').forEach(accordion => {
                if (accordion !== accordionRef.current) {
                    const toggleButton = accordion.querySelector('.accordion-toggle');
                    if (toggleButton && toggleButton.classList.contains('active')) {
                        toggleButton.click();
                    }
                }
            })
        }
        setIsOpen(!isOpen);
    };

    return (
        <div className="accordion" ref={accordionRef}>
            <button
                className={`accordion-toggle ${isOpen ? "active" : ""}`}
                onClick={toggleAccordion}
            >
                <h3 className="title-content">
                    <span>{isOpen ? "▼" : "►"}</span> {title} {duration}
                </h3>
            </button>
            <div
                ref={contentHeight}
                className="description-container"
                style={{
                    maxHeight: height,
                    overflow: isOpen ? "visible" : "hidden",
                    transition: "max-height 0.3s ease",
                }}
            >
                <div className="content-inner" style={{
                    paddingBlock: isOpen ? "15px" : "0",
                    transitionDelay: isOpen ? "0s" : "0.3s"
                }}>
                    {Array.isArray(description) ? (
                        description.map((description, index) => (
                            <ul
                                key={index}
                                className="description-content"><li>{description}</li>
                            </ul>
                        ))
                    ) : (
                        <p className="description-content">{description}</p>
                    )}
                    {moreinfo && <p className="more-info_content">{moreinfo}</p>}
                </div>
            </div>
        </div>
    );
};

export default Accordion;